import { useClass } from '@/hooks/useClass'

export type OutlinedButtonProps = React.ComponentProps<'button'>

export const OutlinedButton = ({
  className,
  children,
  ...props
}: OutlinedButtonProps) => {
  const buttonClass = useClass(
    'w-full py-[14px] text-sm font-bold rounded-[35px] border border-primary',
    className
  )

  return (
    <button type="button" className={buttonClass} {...props}>
      {children}
    </button>
  )
}
